"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _jquery = _interopRequireDefault(require("jquery"));

var _iscrollProbe = _interopRequireDefault(require("iscroll/build/iscroll-probe"));

var _uiStickuplayoutSd = _interopRequireDefault(require("@ctmobile/ui-stickuplayout-sd"));

/** *
 * 选择器
 */
var SELECTORS = {
  column: '.ct-cascadecompared-indicator > .ct-cascadecompared-autoWrap > .ct-cascadecompared-item > .ct-cascadecompared-cell',
  indicatorFixedWrap: '.ct-cascadecompared-indicator > .ct-cascadecompared-fixedWrap',
  indicatorAutoWrap: '.ct-cascadecompared-indicator > .ct-cascadecompared-autoWrap',
  masterFixedWrap: '.ct-cascadecompared-master > .ct-cascadecompared-master-inner > .ct-stickuplayout-inner > .ct-stickuplayout-item > .ct-stickuplayout-item-content > .ct-cascadecompared-fixedWrap',
  masterAutoWrap: '.ct-cascadecompared-master > .ct-cascadecompared-master-inner > .ct-stickuplayout-inner > .ct-stickuplayout-item > .ct-stickuplayout-item-content > .ct-cascadecompared-autoWrap',
  indicatorFirstCell: '.ct-cascadecompared-indicator > .ct-cascadecompared-fixedWrap > .ct-cascadecompared-item > .ct-cascadecompared-cell',
  indicatorCellOfType: function indicatorCellOfType(index) {
    return ".ct-cascadecompared-indicator > .ct-cascadecompared-autoWrap > .ct-cascadecompared-item > .ct-cascadecompared-cell:nth-of-type(".concat(index, ")");
  },
  masterCellOfType: function masterCellOfType(index) {
    return ".ct-cascadecompared-master > .ct-cascadecompared-master-inner > .ct-stickuplayout-inner > .ct-stickuplayout-item > .ct-stickuplayout-item-content > .ct-cascadecompared-autoWrap .ct-cascadecompared-item > .ct-cascadecompared-cell:nth-of-type(".concat(index, ")");
  },
  row: '.ct-cascadecompared-master > .ct-cascadecompared-master-inner > .ct-stickuplayout-inner > .ct-stickuplayout-item > .ct-stickuplayout-item-content > .ct-cascadecompared-fixedWrap > .ct-cascadecompared-item',
  indicator: 'ct-cascadecompared-indicator',
  masterFixedWrapRow: '.ct-cascadecompared-master > .ct-cascadecompared-master-inner > .ct-stickuplayout-inner > .ct-stickuplayout-item > .ct-stickuplayout-item-content > .ct-cascadecompared-fixedWrap > .ct-cascadecompared-item',
  masterAutoWrapRow: '.ct-cascadecompared-master > .ct-cascadecompared-master-inner > .ct-stickuplayout-inner > .ct-stickuplayout-item > .ct-stickuplayout-item-content > .ct-cascadecompared-autoWrap > .ct-cascadecompared-autoInner > .ct-cascadecompared-item'
};
/**
 * isAuto
 * @access private
 */

function isAuto(value) {
  return !value || value === 'undefined' || value === null || value === '' || value === 'auto';
}
/**
 * initScroll
 * @access private
 */


function initScroll() {
  var self = this;
  this.wrapEls = this.el.querySelectorAll('.ct-cascadecompared-autoWrap');

  for (var i = 0; i < this.scrolls.length; i++) {
    this.scrolls[i].destroy();
  }

  this.scrolls = [];

  for (var _i = 0; _i < this.wrapEls.length; _i++) {
    var scroll = new _iscrollProbe["default"](this.wrapEls[_i], {
      probeType: 3,
      eventPassthrough: true,
      scrollX: true,
      scrollY: false,
      preventDefault: false
    });
    this.scrolls.push(scroll);
    scroll.on('scroll', function () {
      for (var j = 0; j < self.scrolls.length; j++) {
        if (self.scrolls[j] !== this) {
          self.scrolls[j].scrollTo(this.x, this.y);
        }
      }
    });
    scroll.on('scrollEnd', function () {
      if (self.stickup.events.scrollEnd) {
        self.stickup.events.scrollEnd();
      }
    });
  }
}
/**
 * position 初始化
 * @access private
 */


function initial() {
  this.scrolls = []; // 初始化stickup

  initDimension.call(this);
  this.stickup = (0, _uiStickuplayoutSd["default"])(this.el);
  initScroll.call(this);
}
/**
 * 计算尺寸
 * @access private
 */


function initDimension() {
  var _this$config = this.config,
      _this$config$columnsW = _this$config.columnsWidth,
      columnsWidth = _this$config$columnsW === void 0 ? [] : _this$config$columnsW,
      _this$config$rowsHeig = _this$config.rowsHeight,
      rowsHeight = _this$config$rowsHeig === void 0 ? [] : _this$config$rowsHeig; // 获取有多少列

  var columnCellLength = this.el.querySelectorAll(SELECTORS.column).length; // 设置列的宽度

  for (var i = 0; i < columnCellLength + 1; i++) {
    var value = void 0;

    if (i === 0) {
      // 第一列
      if (isAuto(columnsWidth[0])) {// 自动宽度,宽度需要计算
        // value = computeAutoMaxValue.call(this, [SELECTORS.indicatorFirstCell, SELECTORS.masterFixedWrap], 'height');
      } else {
        // 设置列值
        value = columnsWidth[0];
      }

      this.$el.find(SELECTORS.indicatorFixedWrap).css('width', "".concat(parseInt(value), "px"));
      this.$el.find(SELECTORS.indicatorAutoWrap).css('margin-left', "".concat(parseInt(value), "px"));
      this.$el.find(SELECTORS.masterFixedWrap).css('width', "".concat(parseInt(value), "px"));
      this.$el.find(SELECTORS.masterAutoWrap).css('margin-left', "".concat(parseInt(value), "px"));
    } else {
      // 其他列
      if (isAuto(columnsWidth[i])) {// 自动宽度，宽度需要计算
        // value = computeAutoMaxValue();
      } else {
        // 设置列值
        value = columnsWidth[i];
      }

      this.$el.find(SELECTORS.indicatorCellOfType(i)).css('width', "".concat(parseInt(value), "px"));
      this.$el.find(SELECTORS.masterCellOfType(i)).css('width', "".concat(parseInt(value), "px"));
    }
  } // 获取有多少行


  var rowLength = this.$el.find(SELECTORS.row).length; // 设置行的高度

  for (var _i2 = 0; _i2 < rowLength + 1; _i2++) {
    var _value = void 0;

    if (_i2 === 0) {
      // 第一行
      if (isAuto(rowsHeight[0])) {// 自动高度,高度需要计算
        // value = computeAutoMaxValue();
      } else {
        // 设置了行值
        _value = rowsHeight[0];
      }

      this.$el.find(SELECTORS.indicator).css('height', "".concat(parseInt(_value), "px"));
    } else {
      if (isAuto(rowsHeight[_i2])) {// 自动高度,高度需要计算
        // value = computeAutoMaxValue();
      } else {
        // 其他行
        _value = rowsHeight[_i2];
      }

      this.$el.find(SELECTORS.masterFixedWrapRow).eq(_i2 - 1).css('height', "".concat(_value, "px"));
      this.$el.find(SELECTORS.masterAutoWrapRow).eq(_i2 - 1).css('height', "".concat(_value, "px"));
    }
  }
}
/**
 * CascadeCompared
 * @class CascadeCompared
 * @classdesc CascadeCompared
 */


var CascadeCompared =
/*#__PURE__*/
function () {
  /**
   * constructor
   * @param {HTMLElement} el
   * @param {Object} config {
   *   columnsWidth: [] 所有列的宽度 从头开始 如果自动设置为auto 否则是number数字 如果没有设置则是auto
   *   rowsHeight: [] 所有行的高度 从头开始 如果自动设置为auto 否则是number数字 如果没有设置则是auto
   * }
   */
  function CascadeCompared(el, config) {
    (0, _classCallCheck2["default"])(this, CascadeCompared);
    this.el = el;
    this.$el = (0, _jquery["default"])(this.el);
    this.config = JSON.parse(JSON.stringify(config));
    initial.call(this);
  }
  /**
   * scrollToByIndex
   * @param {number} index
   * @param {number} duration
   * @return {boolean}
   */


  (0, _createClass2["default"])(CascadeCompared, [{
    key: "scrollToByIndex",
    value: function scrollToByIndex(index) {
      var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 300;
      this.stickup.scrollToByIndex(index, duration);
    }
    /**
     * scrollToByHeaderEl
     * @param {HtmlElement} headerEl
     * @param {number} duration
     * @return {boolean}
     */

  }, {
    key: "scrollToByHeaderEl",
    value: function scrollToByHeaderEl(headerEl) {
      var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 300;
      this.stickup.scrollToByHeaderEl(headerEl, duration);
    }
    /**
     * scrollToByColumn
     * @param {number} columnIndex
     */

  }, {
    key: "scrollToByColumn",
    value: function scrollToByColumn(columnIndex) {
      var scroll = this.scrolls[0];
      scroll.scrollToElement((0, _jquery["default"])(scroll.wrapper).find(".ct-cascadecompared-item .ct-cascadecompared-cell:nth-of-type(".concat(columnIndex, ")"))[0]);
    }
    /**
     * 刷新
     */

  }, {
    key: "refresh",
    value: function refresh() {
      initDimension.call(this);
      initScroll.call(this);
      this.stickup.refresh();
    }
    /**
     * 注册事件
     * @param {string} type 事件类型
     * @param {Function} handler 事件处理函数
     */

  }, {
    key: "on",
    value: function on(type, handler) {
      this.stickup.on(type, handler);
    }
  }]);
  return CascadeCompared;
}();
/**
 * CascadeComparedFactory
 */


var CascadeComparedFactory = {
  /**
   * initTouch
   */
  initTouch: function initTouch() {
    function isPassive() {
      var supportsPassiveOption = false;

      try {
        addEventListener('test', null, Object.defineProperty({}, 'passive', {
          get: function get() {
            supportsPassiveOption = true;
          }
        }));
      } catch (e) {}

      return supportsPassiveOption;
    }

    document.addEventListener('touchmove', function (e) {
      e.preventDefault();
    }, isPassive() ? {
      capture: false,
      passive: false
    } : false);
  },

  /**
   * 创建一个CascadeCompared
   * @param {HtmlElement} - el
   * @param {Object} - config
   * @return {CascadeCompared} - CascadeCompared
   */
  create: function create(el) {
    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return new CascadeCompared(el, config);
  }
};
var _default = CascadeComparedFactory;
exports["default"] = _default;